import { createSlice } from "@reduxjs/toolkit";

const purchaseReportSlice = createSlice({
  name: "purchaseReport",
  initialState: {
    isLoading: {
      purchaseReportByVendor: false,
      purchaseReportByProduct: false,
    },
    purchaseReportByVendor: [],
    purchaseReportByProduct: [],
  },
  reducers: {
    onLoading(state, action) {
      state.isLoading[action.payload] = true;
    },
    rejectedActions(state, action) {
      state.isLoading[action.payload.name] = false;
      state.error = action.payload;
    },
    loadedPurchaseReportByVendor(state, action) {
      let result = [];
      action.payload.reduce(function (res, value) {
        if (!res[value.contact_document_id]) {
          res[value.contact_document_id] = {
            contact_document_id: value.contact_document_id,
            contact_name: value.contact.contact_name_1,
            total_purchase_order: 0,
            sum_pre_vat_amount_exclude_discount: 0,
            sum_item_discount: 0,
            sum_additional_discount: 0,
            sum_pre_vat_amount_include_discount: 0,
            sum_vat_amount: 0,
            sum_net_amount: 0,
            sum_withholding_tax: 0,
            sum_shipping_cost: 0,
            sum_total_amount: 0,
          };
          result.push(res[value.contact_document_id]);
        }

        const sum_pre_vat_amount_exclude_discount = value.item_list.reduce(
          (prev, curr) => prev + curr.qty * curr.price_per_unit,
          0
        );

        const sum_item_discount = value.item_list.reduce(
          (prev, curr) => prev + curr.discount_amount,
          0
        );

        const sum_additional_discount =
          res[value.contact_document_id].sum_additional_discount +
          value.additional_discount;

        const sum_pre_vat_amount_include_discount =
          sum_pre_vat_amount_exclude_discount -
          (sum_item_discount + sum_additional_discount);

        const sum_vat_amount =
          res[value.contact_document_id].sum_vat_amount + value.vat_amount;

        const sum_net_amount =
          sum_pre_vat_amount_include_discount + sum_vat_amount;

        const sum_withholding_tax =
          res[value.contact_document_id].sum_withholding_tax +
          value.withholding_tax_amount;

        const sum_shipping_cost =
          res[value.contact_document_id].sum_shipping_cost +
          value.shipping_cost;

        const sum_total_amount =
          res[value.contact_document_id].sum_total_amount + value.total_amount;

        res[value.contact_document_id].total_purchase_order =
          res[value.contact_document_id].total_purchase_order + 1;
        res[value.contact_document_id].sum_pre_vat_amount_exclude_discount =
          sum_pre_vat_amount_exclude_discount;
        res[value.contact_document_id].sum_item_discount = sum_item_discount;
        res[value.contact_document_id].sum_additional_discount =
          sum_additional_discount;
        res[value.contact_document_id].sum_pre_vat_amount_include_discount =
          sum_pre_vat_amount_include_discount;
        res[value.contact_document_id].sum_vat_amount = sum_vat_amount;
        res[value.contact_document_id].sum_net_amount = sum_net_amount;
        res[value.contact_document_id].sum_withholding_tax =
          sum_withholding_tax;
        res[value.contact_document_id].sum_shipping_cost = sum_shipping_cost;
        res[value.contact_document_id].sum_total_amount = sum_total_amount;
        return res;
      }, {});

      state.purchaseReportByVendor = result;
      state.isLoading.purchaseReportByVendor = false;
    },

    loadedPurchaseReportByProduct(state, action) {
      let result = [];
      action.payload.reduce(function (res, value) {
        if (!res[value.item_document_id]) {
          res[value.item_document_id] = {
            item_document_id: value.item_document_id,
            item_name: value.item_name,
            sum_qty: 0,
            uom: value.uom,
            sum_pre_vat_amount_exclude_discount: 0,
            sum_item_discount: 0,
            sum_item_additional_discount: 0,
            sum_pre_vat_amount_include_discount: 0,
            sum_item_vat_amount: 0,
            sum_item_net_amount: 0,
            sum_item_withholding_tax: 0,
            sum_item_total_amount: 0,
            sum_item_returned_qty: 0,
          };
          result.push(res[value.item_document_id]);
        }

        const sum_qty = res[value.item_document_id].sum_qty + value.qty;

        const sum_pre_vat_amount_exclude_discount =
          res[value.item_document_id].sum_pre_vat_amount_exclude_discount +
          value.pre_vat_amount_exclude_discount;

        const sum_item_discount =
          res[value.item_document_id].sum_item_discount + value.item_discount;

        const sum_item_additional_discount =
          res[value.item_document_id].sum_item_additional_discount +
          value.item_additional_discount;

        const sum_pre_vat_amount_include_discount =
          res[value.item_document_id].sum_pre_vat_amount_include_discount +
          value.pre_vat_amount_include_discount;

        const sum_item_vat_amount =
          res[value.item_document_id].sum_item_vat_amount +
          value.item_vat_amount;

        const sum_item_net_amount =
          res[value.item_document_id].sum_item_net_amount +
          value.item_net_amount;

        const sum_item_withholding_tax =
          res[value.item_document_id].sum_item_withholding_tax +
          value.item_withholding_tax;

        const sum_item_total_amount =
          res[value.item_document_id].sum_item_total_amount +
          value.item_total_amount;

        const sum_item_returned_qty =
          res[value.item_document_id].sum_item_returned_qty +
          value.item_returned_qty;

        res[value.item_document_id].sum_qty = sum_qty;
        res[value.item_document_id].sum_pre_vat_amount_exclude_discount =
          sum_pre_vat_amount_exclude_discount;
        res[value.item_document_id].sum_item_discount = sum_item_discount;
        res[value.item_document_id].sum_item_additional_discount =
          sum_item_additional_discount;
        res[value.item_document_id].sum_pre_vat_amount_include_discount =
          sum_pre_vat_amount_include_discount;
        res[value.item_document_id].sum_item_vat_amount = sum_item_vat_amount;
        res[value.item_document_id].sum_item_net_amount = sum_item_net_amount;
        res[value.item_document_id].sum_item_withholding_tax =
          sum_item_withholding_tax;
        res[value.item_document_id].sum_item_total_amount =
          sum_item_total_amount;
        res[value.item_document_id].sum_item_returned_qty =
          sum_item_returned_qty;
        return res;
      }, {});

      state.purchaseReportByProduct = result;
      state.isLoading.purchaseReportByProduct = false;
    },
    resetPurchaseByVendor(state) {
      state.purchaseReportByVendor = [];
    },
    resetPurchaseByProduct(state) {
      state.purchaseReportByProduct = [];
    },
  },
});

export const purchaseReportActions = purchaseReportSlice.actions;

export default purchaseReportSlice.reducer;
